/**
 * Welcome Page
 */

import React from 'react';
import { Card, Stack, Flex, useTheme, spacing, textStyles, fontSize } from '@fti/design-system';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../auth/hooks';

const QUICK_LINKS = [
  { label: 'Clients', path: '/clients', desc: 'Manage client records' },
  { label: 'Matters', path: '/matters', desc: 'Manage matters under clients' },
  { label: 'Projects', path: '/projects', desc: 'Manage projects and versions' },
  { label: 'LexisNexis', path: '/lexisnexis', desc: 'Register LexisNexis data sources' },
  { label: 'Brandwatch', path: '/brandwatch', desc: 'Register Brandwatch data sources' },
  { label: 'Models', path: '/models', desc: 'Associate ML models with projects' },
  { label: 'Vectorize', path: '/vectorize', desc: 'Configure embedding pipelines' },
  { label: 'Air Traffic Control', path: '/atc', desc: 'Launch and manage pipelines' },
];

export function WelcomePage() {
  const { theme } = useTheme();
  const user = useUser();
  const navigate = useNavigate();

  const textColor = theme.colors.text.primary;
  const mutedColor = theme.colors.text.secondary;

  return (
    <Stack gap="lg">
      <div>
        <h1 style={{ ...textStyles.h3, color: textColor }}>
          Welcome{user?.email ? `, ${user.email.split('@')[0]}` : ''}
        </h1>
        <p style={{ margin: 0, marginTop: spacing.xs, ...textStyles.body, color: mutedColor }}>
          Internal tools for managing clients, matters, projects, data sources, and pipelines.
        </p>
      </div>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
        gap: spacing.md,
      }}>
        {QUICK_LINKS.map((link) => (
          <Card
            key={link.path}
            variant="elevated"
            style={{ cursor: 'pointer', transition: 'transform 0.1s, box-shadow 0.1s' }}
            onClick={() => navigate(link.path)}
          >
            <Card.Body>
              <h3 style={{ margin: 0, ...textStyles.label, color: textColor }}>
                {link.label}
              </h3>
              <p style={{ margin: 0, marginTop: spacing.xs, fontSize: fontSize.sm, color: mutedColor }}>
                {link.desc}
              </p>
            </Card.Body>
          </Card>
        ))}
      </div>
    </Stack>
  );
}
